import { atom } from "jotai";

import { PatronCancelBooking } from "../../types";
import { currentBookingAtom, originalBookingAtom } from "../stores";

type Payload = {
  booking: PatronCancelBooking.Booking;
};
export const initializeCancelBookingModalAtom = atom(
  null,
  (get, set, payload: Payload) => {
    const booking = payload.booking;
    set(originalBookingAtom, booking);
    set(currentBookingAtom, booking);
  }
);
